import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { PostResponse } from '../studio-http-client/post-response';
import { StartSession } from '../models/start-session';
import { HttpAction } from '../studio-http-client/http-action.enum';
import { HttpHeaders } from '@angular/common/http';
import { EndSession } from '../models/end-session';
import { GetMpSandboxSessionTimeRequest } from '../models/get-mp-sandbox-session-time-request';
import { MpSandboxSessionTimeResponse } from '../models/mp-sandbox-session-time-response';
import { UserDetailsWithHighestUsageTrialRequest } from './user-details-with-highest-usage-trial-request';
import { UserWithHighestUsageTrialResponse } from '../models/user-with-highest-usage-trial-response';

@Injectable({
  providedIn: 'root',
})
export class SessionsService {
  apiService = inject(ApiService);

  postStartSession(userId: string, startSession: StartSession): Observable<PostResponse> {
    if (!userId || userId === 'null') {
      console.error('null userId');
      throw Error('null userId');
    }
    const url = `api/Users/${userId}/Sessions/Start`;
    return this.apiService.invokeLSApi<PostResponse>(url, HttpAction.Post, startSession);
  }

  postEndSession(userId: string, endSession: EndSession): Observable<PostResponse> {
    const url = `api/Users/${userId}/Sessions/End`;
    return this.apiService.invokeLSApi<PostResponse>(url, HttpAction.Put, endSession, {
      additionalHeaders: new HttpHeaders({ UserId: userId }),
    }); // for when this is called when the next user logs in to a different shard
  }

  getMpSandboxSessionTime(request: Partial<GetMpSandboxSessionTimeRequest>) {
    const url = 'api/Sessions/GetMpSandboxSessionTime';

    return this.apiService.invokeLSApi<MpSandboxSessionTimeResponse[]>(
      url,
      HttpAction.PostWithBodyResponse,
      request
    );
  }

  getUserDetailsWithHighestUsageTrial(request: UserDetailsWithHighestUsageTrialRequest) {
    const url = 'api/Sessions/GetUserDetailsWithHighestUsageTrial';

    return this.apiService.invokeLSApi<UserWithHighestUsageTrialResponse[]>(
      url,
      HttpAction.PostWithBodyResponse,
      request
    );
  }
}
